var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TotemFilterResult',{attrs:{"listLength":_vm.filteredCount}}),_c('Sorter'),(!_vm.canShowListToggleView)?_c('CourseListViewToggle'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }